import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["anchorEl", "onClose", "placement", "className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
import { twMerge } from 'tailwind-merge';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A popover anchored to `anchorEl`, portaled out of any clipped/overflow parent,
 * closing on Escape or a pointer down outside the panel and its anchor. The
 * anchor is excluded from the outside-close so the trigger's own click can
 * toggle the popover shut, instead of this closing it first and the trigger
 * immediately reopening it.
 */
var AnchoredPopover = function AnchoredPopover(_ref) {
  var anchorEl = _ref.anchorEl,
    onClose = _ref.onClose,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top-start' : _ref$placement,
    className = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    popperElement = _useState2[0],
    setPopperElement = _useState2[1];
  var _usePopper = usePopper(anchorEl, popperElement, {
      placement: placement,
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, 8]
        }
      }, {
        name: 'flip',
        options: {
          flipVariations: true
        }
      }, {
        name: 'preventOverflow',
        options: {
          padding: 8
        }
      }]
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    var handlePointerDown = function handlePointerDown(event) {
      var target = event.target;
      if (popperElement !== null && popperElement !== void 0 && popperElement.contains(target) || anchorEl !== null && anchorEl !== void 0 && anchorEl.contains(target)) {
        return;
      }
      onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('touchstart', handlePointerDown);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('touchstart', handlePointerDown);
    };
  }, [onClose, anchorEl, popperElement]);
  return /*#__PURE__*/createPortal(/*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({}, rest), {}, {
    ref: setPopperElement,
    style: styles.popper
  }, attributes.popper), {}, {
    className: twMerge('z-50', className),
    children: children
  })), document.getElementById('contextMenuPortal') || document.body);
};
export default AnchoredPopover;